import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";

const customerActivitiesResponse = {
  customer_id: "CUST-00123",
  total: 84,
  page: 1,
  page_size: 25,
  total_pages: 4,
  activities: [
    {
      id: "ACT-001",
      timestamp: "2026-04-09T10:32:00Z",
      timestamp_formatted: "09 Apr 2026, 10:32 AM",
      activity: "Login successful",
      description: "Customer logged in successfully",
      category: "authentication",
      category_label: "Authentication",
      ip_address: "192.168.1.1",
      channel: "Mobile App",
      status: "success",
    },
    {
      id: "ACT-002",
      timestamp: "2026-04-09T09:14:00Z",
      timestamp_formatted: "09 Apr 2026, 09:14 AM",
      activity: "Transaction initiated",
      description: "Transfer of ₦50,000 to GTBank account",
      category: "transaction",
      category_label: "Transaction",
      ip_address: "102.89.4.22",
      channel: "Web",
      status: "success",
    },
    {
      id: "ACT-003",
      timestamp: "2026-04-08T18:45:00Z",
      timestamp_formatted: "08 Apr 2026, 06:45 PM",
      activity: "KYC document uploaded",
      description: "Utility bill uploaded for Tier 3 upgrade",
      category: "kyc",
      category_label: "KYC",
      ip_address: "102.89.4.22",
      channel: "Web",
      status: "success",
    },
    {
      id: "ACT-004",
      timestamp: "2026-04-08T14:10:00Z",
      timestamp_formatted: "08 Apr 2026, 02:10 PM",
      activity: "Login failed",
      description: "Incorrect PIN entered — 2 of 3 attempts used",
      category: "authentication",
      category_label: "Authentication",
      ip_address: "41.203.78.12",
      channel: "Mobile App",
      status: "failed",
    },
    {
      id: "ACT-005",
      timestamp: "2026-04-07T11:55:00Z",
      timestamp_formatted: "07 Apr 2026, 11:55 AM",
      activity: "Password changed",
      description: "Customer updated their login password",
      category: "profile",
      category_label: "Profile",
      ip_address: "102.89.4.22",
      channel: "Web",
      status: "success",
    },
    {
      id: "ACT-006",
      timestamp: "2026-04-07T09:30:00Z",
      timestamp_formatted: "07 Apr 2026, 09:30 AM",
      activity: "Transaction failed",
      description: "Transfer of ₦200,000 failed — insufficient funds",
      category: "transaction",
      category_label: "Transaction",
      ip_address: "102.89.4.22",
      channel: "Web",
      status: "failed",
    },
    {
      id: "ACT-007",
      timestamp: "2026-04-06T16:20:00Z",
      timestamp_formatted: "06 Apr 2026, 04:20 PM",
      activity: "Profile updated",
      description: "Customer updated phone number",
      category: "profile",
      category_label: "Profile",
      ip_address: "102.89.4.22",
      channel: "Mobile App",
      status: "success",
    },
    {
      id: "ACT-008",
      timestamp: "2026-04-06T08:05:00Z",
      timestamp_formatted: "06 Apr 2026, 08:05 AM",
      activity: "Product subscribed",
      description: "Customer subscribed to Virtual Account product",
      category: "product",
      category_label: "Product",
      ip_address: "102.89.4.22",
      channel: "Web",
      status: "success",
    },
    {
      id: "ACT-009",
      timestamp: "2026-04-05T13:44:00Z",
      timestamp_formatted: "05 Apr 2026, 01:44 PM",
      activity: "OTP requested",
      description: "OTP sent to registered phone number",
      category: "authentication",
      category_label: "Authentication",
      ip_address: "41.203.78.12",
      channel: "Mobile App",
      status: "success",
    },
    {
      id: "ACT-010",
      timestamp: "2026-04-05T10:00:00Z",
      timestamp_formatted: "05 Apr 2026, 10:00 AM",
      activity: "KYC tier upgraded",
      description:
        "Account upgraded from Tier 1 to Tier 2 after NIN verification",
      category: "kyc",
      category_label: "KYC",
      ip_address: null,
      channel: "System",
      status: "success",
    },
  ],
};

export const fetchCustomerActivitiesMock = (customerId, params = {}) => {
  const {
    page = 1,
    page_size = 25,
    category = null,
    status = null,
    search = null,
    date_from = null,
    date_to = null,
  } = params;

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(customerActivitiesResponse);
    }, 400);
  });
};

const subscribedProductsResponse = {
  customer_id: "CUST-00123",
  total_subscribed: 4,
  products: [
    {
      id: "collection",
      name: "Collection",
      type: "Payment",
      status: "active",
      subscribed_date: "2025-01-12",
      subscribed_date_formatted: "12 Jan 2025",
      last_30_days: {
        volume: 2400000,
        volume_formatted: "₦2.4M",
        count: 142,
      },
    },
    {
      id: "payout",
      name: "Payout",
      type: "Transfer",
      status: "active",
      subscribed_date: "2025-01-12",
      subscribed_date_formatted: "12 Jan 2025",
      last_30_days: {
        volume: 1800000,
        volume_formatted: "₦1.8M",
        count: 89,
      },
    },
    {
      id: "virtual_account",
      name: "Virtual Account",
      type: "Payment",
      status: "inactive",
      subscribed_date: "2025-03-04",
      subscribed_date_formatted: "04 Mar 2025",
      last_30_days: {
        volume: 0,
        volume_formatted: "₦0",
        count: 0,
      },
    },
    {
      id: "ussd",
      name: "USSD",
      type: "Payment",
      status: "suspended",
      subscribed_date: "2025-02-20",
      subscribed_date_formatted: "20 Feb 2025",
      last_30_days: {
        volume: 0,
        volume_formatted: "₦0",
        count: 0,
      },
    },
  ],
};

export const fetchSubscribedProductsMock = (customerId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(subscribedProductsResponse);
    }, 400);
  });
};

export const AdminSummary = [
  {
    title: "Total Admin Users",
    objKeyRepr: "totalAdminUser",
    icon: <AdminPanelSettingsOutlinedIcon fontSize="small" />,
  },
  {
    title: "Total Invitees Pending",
    objKeyRepr: "totalInviteesPending",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" />,
  },
  {
    title: "Total Active Users",
    objKeyRepr: "totalActiveUsers",
    icon: <CheckCircleOutlineIcon fontSize="small" />,
  },
];

export const TotalSummary = [
  {
    title: "Total Registered Users",
    objKeyRepr: "totalRegisteredUsers",
    icon: <PeopleOutlineIcon fontSize="small" />,
  },
  {
    title: "Total Active Users",
    objKeyRepr: "activeUsers",
    icon: <CheckCircleOutlineIcon fontSize="small" />,
  },
  {
    title: "Total Inactive Users",
    objKeyRepr: "inActiveUsers",
    icon: <CancelOutlinedIcon fontSize="small" />,
  },
];

export const ReferralSummary = [
  {
    title: "Total Number of Referral Codes Used",
    total: 850,
  },
  {
    title: "Total Users Registered with Referral Code",
    total: 20000,
  },
];
